//components
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

export const LoaderText = () => (
    <div className="border-b border-icoGray-300 p-8 dark:border-icoDarkMode-beton xl:px-7 xl:py-10 xl:pb-10">
        <div className="flex w-full animate-pulse flex-col space-y-m">
            <span className="block h-5 w-2/3 rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            <div className="mb-m flex w-full flex-col gap-2">
                <p className="h-3 w-full rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <p className="h-3 w-full rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <p className="h-3 w-full rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            </div>
        </div>
    </div>
);

export function PageLoading() {
    return (
        <>
            <SettingsWrapper.MainContent data-testid="new-plan-loading">
                <span className="mb-5 block h-5 w-44 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <div className="flex w-full animate-pulse flex-col gap-2.5">
                    <div className="h-[11.3rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                    {[1, 2, 3].map((el) => (
                        <div
                            key={el}
                            className="h-[5.375rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack"
                        />
                    ))}
                </div>
            </SettingsWrapper.MainContent>
            <SettingsWrapper.SideContent>
                {[1, 2, 3].map((el) => (
                    <LoaderText key={el} />
                ))}
            </SettingsWrapper.SideContent>
        </>
    );
}
